import React from "react";
import {
    IEmpCardStrategyViewModel
} from "../../../../../services/booking/models/payment/methods/card/strategies/emp/emp-card-strategy.view-model.interface";
import styled from "styled-components";
import {observer} from "mobx-react";
import {SupportedCardNetworksSmallComponent} from "../supported-card-networks-small.component";
import {StandardCardDetailsEditorComponent} from "../standard-card-details-editor.component";

const TabContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.spacing20};
    width: 100%;
`



export const EmpCardPaymentMethodsTabContentComponent: React.FC<{empStrategy: IEmpCardStrategyViewModel}> = observer((props) => {

    return (
        <TabContainerBox>
            <SupportedCardNetworksSmallComponent networks={props.empStrategy.cardNetworks}/>
            <StandardCardDetailsEditorComponent fields={props.empStrategy.fields}/>
        </TabContainerBox>
    )
})